module.exports = __webpack_public_path__ + "static/pdb_logo-61a296ddd14f2e54f26d0bbf8d1d2f79.svg";